module.exports = __webpack_public_path__ + "img/g.572860f7.jpg";